"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var _date_picker_1 = tslib_1.__importDefault(require("../_components/_date-picker"));
var zh_CN_1 = tslib_1.__importDefault(require("../_components/_date-picker/locale/zh_CN"));
var checkbox_1 = tslib_1.__importDefault(require("../checkbox"));
var formatStr = 'YYYY/MM/DD';
var formatMonthStr = 'YYYY/MM';
var formatTimeStr = 'YYYY/MM/DD HH:mm:ss';
var RangePicker = _date_picker_1.default.RangePicker;
var AnqDatePicker = function (props) {
    var style = props.style, className = props.className, rest = tslib_1.__rest(props, ["style", "className"]);
    var pickerWidth = props.size === 'large' ? 280 : 240;
    var _a = (0, react_1.useMemo)(function () {
        if (props.picker === 'week') {
            return {
                placeholder: '请选择第几周',
                format: function (value) {
                    return "".concat((0, moment_1.default)(value).format('YYYY/WW周'), "\uFF08").concat((0, moment_1.default)(value)
                        .weekday(0)
                        .format('MM/DD'), " ~ ").concat((0, moment_1.default)(value).weekday(6).format('MM/DD'), "\uFF09");
                },
            };
        }
        if (props.picker === 'month') {
            return {
                format: formatMonthStr,
            };
        }
        return {
            format: props.showTime ? formatTimeStr : formatStr,
        };
    }, [props.picker, props.showTime]), format = _a.format, placeholder = _a.placeholder;
    return (react_1.default.createElement(_date_picker_1.default, tslib_1.__assign({ className: (0, classnames_1.default)('anq-date-time-picker', className), locale: zh_CN_1.default, format: format, style: tslib_1.__assign({ width: pickerWidth }, style), showToday: false, placeholder: placeholder }, rest)));
};
var stopPropagation = function (e) {
    e.stopPropagation();
};
var AnqRangePicker = function (props) {
    var style = props.style, size = props.size, onChange = props.onChange, showQuickRangePicker = props.showQuickRangePicker, _a = props.showAllowEndEmpty, showAllowEndEmpty = _a === void 0 ? false : _a, value = props.value, className = props.className, ranges = props.ranges, timeOffset = props.timeOffset, _b = props.timeOffsetUnit, timeOffsetUnit = _b === void 0 ? 'd' : _b, rest = tslib_1.__rest(props, ["style", "size", "onChange", "showQuickRangePicker", "showAllowEndEmpty", "value", "className", "ranges", "timeOffset", "timeOffsetUnit"]);
    var _c = tslib_1.__read((0, react_1.useState)(value), 2), curVal = _c[0], setCurVal = _c[1];
    var _d = tslib_1.__read((0, react_1.useState)(['', '']), 2), dateString = _d[0], setDateString = _d[1];
    var _e = tslib_1.__read((0, react_1.useState)(false), 2), allowEndEmpty = _e[0], setAllowEndEmpty = _e[1];
    var _f = tslib_1.__read((0, react_1.useState)(false), 2), isOpen = _f[0], setIsOpen = _f[1];
    var ref = (0, react_1.useRef)(null);
    var currentVal = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        setCurVal(value);
        currentVal.current = value;
    }, [value]);
    (0, react_1.useEffect)(function () {
        if ((value && value[1] === undefined) || (value && value[1] === null)) {
            setAllowEndEmpty(true);
        }
        else {
            setAllowEndEmpty(false);
        }
    }, [value]);
    (0, react_1.useEffect)(function () {
        if (timeOffset) {
            var pickerList = document.getElementsByClassName('anq-date-range-picker-offset');
            for (var i = 0; i < pickerList.length; i++) {
                var inputList = pickerList[i].querySelectorAll('.anq-picker-input');
                if (inputList[1]) {
                    inputList[1].addEventListener('click', stopPropagation);
                }
            }
        }
    }, [timeOffset]);
    var format = (0, react_1.useMemo)(function () {
        if (props.picker === 'month') {
            if (!isOpen) {
                return formatStr;
            }
            return formatMonthStr;
        }
        return [formatStr, allowEndEmpty ? '不限' : formatStr];
    }, [allowEndEmpty, props.picker, isOpen]);
    var needMergeTime = (0, react_1.useMemo)(function () {
        var picker = props.picker, showTime = props.showTime;
        if (!showTime) {
            // 只有是日期选择器才合并显示
            if (picker === 'date' || picker === undefined) {
                if (curVal && curVal[0] && curVal[1]) {
                    return (0, moment_1.default)(curVal[0]).format(formatStr) === (0, moment_1.default)(curVal[1]).format(formatStr);
                }
            }
        }
        return false;
    }, [props.showTime, props.picker, curVal]);
    var quickPickOptions = (0, react_1.useMemo)(function () {
        if (!ranges) {
            return [
                {
                    label: '今日',
                    value: [(0, moment_1.default)(), (0, moment_1.default)()],
                },
                {
                    label: '昨日',
                    value: [(0, moment_1.default)().subtract(1, 'days'), (0, moment_1.default)().subtract(1, 'days')],
                },
                {
                    label: '7 天',
                    value: [(0, moment_1.default)().subtract(6, 'days'), (0, moment_1.default)()],
                },
                {
                    label: '30 天',
                    value: [(0, moment_1.default)().subtract(29, 'days'), (0, moment_1.default)()],
                },
                {
                    label: '90 天',
                    value: [(0, moment_1.default)().subtract(89, 'days'), (0, moment_1.default)()],
                },
            ];
        }
        return Object.keys(ranges).map(function (label) {
            var range = ranges[label];
            return {
                label: label,
                value: typeof range === 'function' ? range() : range,
            };
        });
    }, [ranges]);
    var isLarge = size === 'large';
    var handleEndEmptyChange = function (e) {
        var checked = !allowEndEmpty;
        setAllowEndEmpty(checked);
        if (checked) {
            var startDate = curVal ? curVal[0] : null;
            var startDateStr = dateString ? dateString[0] : '';
            if (startDate) {
                onChange && onChange([startDate, null], [startDateStr, '']);
                setTimeout(function () {
                    var _a;
                    // @ts-ignore
                    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
                }, 0);
            }
        }
        e.stopPropagation();
        e.preventDefault();
    };
    var handleOpenChange = function (isOpen) {
        setIsOpen(isOpen);
        props.onOpenChange && props.onOpenChange(isOpen);
        var current = currentVal.current;
        if (!isOpen && !allowEndEmpty && showAllowEndEmpty) {
            if (current && current[0] && !current[1]) {
                onChange && onChange(null, ['', '']);
            }
        }
        if (allowEndEmpty) {
            if (!current) {
                setAllowEndEmpty(false);
            }
            if (current && !current[0]) {
                setAllowEndEmpty(false);
            }
        }
    };
    var onCalendarChange = function (val, dateString) {
        if (timeOffset && val && val[0]) {
            var newVal_1 = [val[0], val[0].clone().add(timeOffset, timeOffsetUnit)];
            var newStr_1 = [newVal_1[0].format(formatStr), newVal_1[1].format(formatStr)];
            currentVal.current = newVal_1;
            setCurVal(newVal_1);
            setDateString(newStr_1);
            setTimeout(function () {
                var _a;
                // @ts-ignore
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
                onChange && onChange(newVal_1, newStr_1);
            }, 10);
            return;
        }
        currentVal.current = val;
        setCurVal(val);
        setDateString(dateString);
        if (val && val[0] && allowEndEmpty) {
            setTimeout(function () {
                var _a;
                // @ts-ignore
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
            }, 50);
            onChange && onChange([val[0], null], [dateString[0], '']);
        }
        if (val && val[1] && allowEndEmpty) {
            setAllowEndEmpty(false);
        }
    };
    var placeholder = (0, react_1.useMemo)(function () {
        if (props.picker === 'month') {
            return ['开始月份', '结束月份'];
        }
        return ['开始日期', allowEndEmpty ? '不限' : '结束日期'];
    }, [allowEndEmpty, props.picker]);
    if (props.showTime) {
        return react_1.default.createElement(RangePicker, tslib_1.__assign({}, props, { className: (0, classnames_1.default)('anq-date-range-picker', className) }));
    }
    return (react_1.default.createElement(RangePicker, tslib_1.__assign({ className: (0, classnames_1.default)('anq-date-range-picker', className, {
            'anq-date-range-picker-offset': !!timeOffset,
            'anq-date-range-picker-merge': needMergeTime,
        }), ref: ref, style: tslib_1.__assign({ width: isLarge ? 280 : 240 }, style), size: size, format: format, locale: zh_CN_1.default, onOpenChange: handleOpenChange, onCalendarChange: onCalendarChange, renderExtraFooter: !showAllowEndEmpty || showQuickRangePicker
            ? undefined
            : function () {
                return (react_1.default.createElement("div", { className: "anq-date-range-picker-footer" },
                    react_1.default.createElement(checkbox_1.default, { checked: allowEndEmpty, onClick: handleEndEmptyChange },
                        react_1.default.createElement("span", { className: 'anq-date-range-picker-footer-label', onClick: handleEndEmptyChange }, "\u7ED3\u675F\u65F6\u95F4\u4E0D\u9650"))));
            }, onChange: function (val, dateString) {
            onChange && onChange(val, dateString);
            if (val === null) {
                setAllowEndEmpty(false);
            }
        }, allowEmpty: [false, allowEndEmpty], value: value, placeholder: placeholder, dropdownClassName: "anq-range-picker-dropdown-cls", panelRender: function (node) {
            if (!showQuickRangePicker) {
                return node;
            }
            return (react_1.default.createElement("div", { style: { minWidth: 656 } },
                react_1.default.createElement("div", { className: "anq-range-picker-quick-selection" }, quickPickOptions.map(function (item, index) {
                    return (react_1.default.createElement("div", { key: index, className: "anq-range-picker-quick-selection-item", onClick: function () {
                            var _a;
                            onChange &&
                                onChange(item.value, item.value.map(function (time) { return time.format(formatStr); }));
                            // @ts-ignore
                            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
                        } }, item.label));
                })),
                node));
        } }, rest)));
};
AnqDatePicker.RangePicker = AnqRangePicker;
var MonthPicker = function (props) {
    return react_1.default.createElement(RangePicker, tslib_1.__assign({ picker: "month" }, props));
};
AnqDatePicker.MonthPicker = MonthPicker;
var QuarterPicker = function (props) {
    return react_1.default.createElement(RangePicker, tslib_1.__assign({ picker: "quarter" }, props));
};
AnqDatePicker.QuarterPicker = QuarterPicker;
var YearPicker = function (props) {
    return react_1.default.createElement(RangePicker, tslib_1.__assign({ picker: "year" }, props));
};
AnqDatePicker.YearPicker = YearPicker;
exports.default = AnqDatePicker;
//# sourceMappingURL=index.js.map